import { toastTypes } from './actions';

const initialState = {
  toastData: {
    type: '',
    props: {}
  }
};

export default (state = initialState, action) => {
  switch (action.type) {
    case toastTypes.OPEN_TOAST.SUCCESS:
      return {
        ...state,
        toastData: action.payload
      };
    case toastTypes.CLOSE_TOAST.SUCCESS:
      return {
        ...state,
        toastData: initialState.toastData
      };
    default:
      return { ...state };
  }
};
